import { GetServerSideProps, NextPage } from 'next';

import { PublishersContent } from '@/components/ui/features/hubs-publishers/PublishersContent/PublishersContent';
import { PublisherSearchInput } from '@/components/ui/features/hubs-publishers/PublisherSearchInput/PublisherSearchInput';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { ThinConferenceSort } from '@/enums/ThinConferenceSort';
import { getHubBySlug, getHubsSubtree } from '@/queries/hubs';
import { queryThinConferencesInfinite } from '@/queries/thin-conferences';
import { generateStore } from '@/utils/generateStore';
import { Hydrate, IHydrateProps } from '@/utils/swr/Hydrate';
import { StringParam, urlQueryStringValidate } from '@/utils/url-query-string';

const Publishers: NextPage<IHydrateProps> = ({ fallback }) => {
  return (
    <Hydrate fallback={fallback}>
      <Layout accessFrom={AccessFrom.Hubs}>
        <PublisherSearchInput />
        <PublishersContent />
      </Layout>
    </Hydrate>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = generateStore({ context });
  const { slug, query, subject_subtree_of_id, sort } = urlQueryStringValidate<{
    slug: string;
    query: string;
    subject_subtree_of_id: Array<string>;
    sort: ThinConferenceSort;
  }>(context.query, {
    slug: StringParam,
    query: StringParam,
    subject_subtree_of_id: StringParam,
    sort: StringParam,
  });

  const { data } = await store.fetchResource(getHubBySlug(slug));
  const { data: subtreeIds } = await store.fetchResourceRelationship(getHubsSubtree(data.id));

  await store.fetchResourcesInfinite(
    queryThinConferencesInfinite(
      {
        query,
        subject_id: subject_subtree_of_id ?? subtreeIds,
        visible: 'true',
      },
      sort
    )
  );

  return {
    props: {
      fallback: store.fallback,
    },
  };
};

export default Publishers;
